export default __webpack_public_path__ + "static/media/counter_reading_project-7.1c158c2a.png";